export default {
  label: '架构师',
  id: '0',
  children: [
    {
      label: '定义',
      id: '0-1',
      children: [
        {
          label: '系统设计的总规划师。',
          id: '0-1-1',
        },
      ],
    },
    {
      label: '职责',
      id: '0-2',
      children: [
        {
          label: '负责系统架构设计，制定技术战略，协调技术团队与业务团队的合作。',
          id: '0-2-1',
        },
      ],
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '具备全面的技术视野，能够选择合适的技术架构和技术方案，注重性能优化和系统扩展性。',
          id: '0-3-1',
        },
      ],
    },
    {
      label: '职业发展',
      id: '0-4',
      children: [
        {
          label: '通常在10年以上经验后晋升为技术总监或CTO。',
          id: '0-4-1',
        },
      ],
    },
    {
      label: '薪资水平',
      id: '0-5',
      children: [
        {
          label: '月薪在30,000-60,000元之间，年薪可达50-100万元。',
          id: '0-5-1',
        },
      ],
    },
  ],
};